import moment from "moment";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  useCustomerFeedback,
  useCSATFeedback,
  useTicketFeedback,
} from "./store";
import FeedbackHeader from "./FeedbackHeader";
import CSATFeedbackTable from "./CSATFeedbackTable";
import TicketFeedbackTable from "./TicketFeedbackTable";
import CustomerTable from "modules/customer_feedback/CustomerTable";
import PaginationDiv from "modules/pagination/PaginationDiv";
import CardDiv from "modules/common/card-div/CardDiv";
import { Button } from "antd";
import { isEmpty } from "lodash";
import { DownloadOutlined } from "@ant-design/icons";
import xlsx from "json-as-xlsx";
import { createSortHandler } from "modules/utilities/utility";

function Feedback() {
  const {
    fetchCustomerFeedback,
    customerFeedbackData,
    isCustomerFeedbackLoading,
  } = useCustomerFeedback();
  const { fetchCSATFeedback, CSATFeedbackData, isCSATFeedbackLoading } =
    useCSATFeedback();
  const { fetchTicketFeedback, ticketFeedback, isTicketFeedbackLoading } =
    useTicketFeedback();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const pageNumber = searchParams.get("pageNumber");
  const sd = searchParams.get("sd");
  const ed = searchParams.get("ed");
  const tab = searchParams.get("tab");
  const [start, setStart] = useState();
  const [end, setEnd] = useState();
  const [startDate, setStartDate] = useState(sd);
  const [endDate, setEndDate] = useState(ed);
  const [startTimeStamp, setStartTimeStamp] = useState();
  const [endTimeStamp, setEndTimeStamp] = useState();
  const [sortData, setSortedData] = useState();
  const [filterData, setFilter] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [opa, setOpa] = useState("");
  const [count, setCount] = useState(0);
  const [page, newPage] = useState(1);
  const [table, setTable] = useState("customer");
  const [feedbackPage, setFeedbackNewPage] = useState(Number(pageNumber) || 1);
  useEffect(() => {}, [ticketFeedback, customerFeedbackData, CSATFeedbackData]);

  const [plan, setPlan] = useState({
    happy_rate_1: 0,
    happy_rate_2: 0,
    happy_rate_3: 0,
    happy_rate_4: 0,
    happy_rate_5: 0,
  });
  const [csatFeedback, setCSATFeedbackData] = useState({
    coach_rating_1: 0,
    coach_rating_2: 0,
    coach_rating_3: 0,
    coach_rating_4: 0,
    coach_rating_5: 0,
    happy_rate_1: 0,
    happy_rate_2: 0,
    happy_rate_3: 0,
    happy_rate_4: 0,
    happy_rate_5: 0,
  });

  const [feedbackData, setFeedbackData] = useState({
    satisfied_0: 0,
    satisfied_1: 0,
    experience_1: 0,
    experience_2: 0,
    experience_3: 0,
    experience_4: 0,
    experience_5: 0,
  });


  useEffect(() => {
    if (customerFeedbackData.length) setSortedData(customerFeedbackData);
  }, [customerFeedbackData]);

  useEffect(() => {
    setTable(tab);
  }, [tab]);

  useEffect(() => {
    setStartTimeStamp(
      +moment(moment().subtract(1, "days"), "YYYY-MM-DD").startOf("day")
    );
    setEndTimeStamp(+moment(moment(), "YYYY-MM-DD").endOf("day"));
    setStartDate(
      moment().subtract(1, "days").format("YYYY-MM-DD") + "T18:30:00.000Z"
    );
    setEndDate(
      moment().format("YYYY-MM-DD") + "T18:29:59.999Z"
    );
    if (start) {
      navigate(
        `/customer-feedback?tab=${tab}&pageNumber=${pageNumber}&sd=${start}&ed=${end}`
      );
    }
  }, []);

  useEffect(() => {
    setFeedbackNewPage(Number(pageNumber));
  }, [pageNumber]);

  useEffect(() => {
    navigate(
      `/customer-feedback?tab=${tab}&pageNumber=${feedbackPage}&sd=${sd}&ed=${ed}`
    );
  }, [feedbackPage]);

  useEffect(() => {
    if (
      startDate != undefined &&
      endDate != undefined &&
      startTimeStamp != undefined &&
      endTimeStamp != undefined
    ) {
      fetchCustomerFeedback(startDate, endDate);
      fetchCSATFeedback(startTimeStamp, endTimeStamp);
    }
  }, [startDate, endDate]);

  useEffect(() => {
    if (startTimeStamp != undefined && endTimeStamp != undefined) {
      fetchTicketFeedback(startTimeStamp, endTimeStamp, feedbackPage);
    }
  }, [feedbackPage, startDate, endDate]);

  function applyDate(date) {
    setStartTimeStamp(moment(date).startOf("day").valueOf());
    setEndTimeStamp(moment(date).endOf("day").valueOf());
    setStartDate(moment(date).format("YYYY-MM-DD") + "T18:30:00.000Z");
    setEndDate(moment(date).format("YYYY-MM-DD") + "T18:29:59.999Z");
    setStart(
      moment(date)
        .startOf("day")
        .format("ddd+MMM+D+YYYY+18%3A30%3A00+GMT%2B0530")
    );
    setEnd(
      moment(date).endOf("day").format("ddd+MMM+D+YYYY+18%3A29%3A99+GMT%2B0530")
    );
  }

  useEffect(() => {
    const numOfSubarrays = Math.max(Math.ceil((sortData?.length || 0) / 10), 0);
    const arrayOfArrays = sortData
      ? Array.from({ length: numOfSubarrays }, (_, i) => {
          const start = i * 10;
          const end = start + 10;
          return sortData?.slice(start, end);
        })
      : [];
    setPageCount(Math.max(Math.ceil((sortData?.length || 0) / 10), 1));
    setFilter(arrayOfArrays[page - 1]);
  }, [sortData, page]);

  const handleSortUpdatedDate = () =>
    createSortHandler(
      "updatedAt",
      count,
      setCount,
      setSortedData,
      setOpa,
      customerFeedbackData || []
    );

  useEffect(() => {
    let planObj = {
      happy_rate_1: 0,
      happy_rate_2: 0,
      happy_rate_3: 0,
      happy_rate_4: 0,
      happy_rate_5: 0,
    };
    if (Array.isArray(sortData)) {
      const updatedPlan = sortData.reduce(
        (prev, curr) => {
          if (curr?.happy_with_traya >= 1 && curr?.happy_with_traya <= 5) {
            const ratingKey = `happy_rate_${curr?.happy_with_traya}`;
            prev[ratingKey] += 1;
          }
          return prev;
        },
        { ...planObj }
      );
      setPlan(() => updatedPlan);
    }
  }, [sortData]);

  useEffect(() => {
    let objData = {
      coach_rating_1: 0,
      coach_rating_2: 0,
      coach_rating_3: 0,
      coach_rating_4: 0,
      coach_rating_5: 0,
      happy_rate_1: 0,
      happy_rate_2: 0,
      happy_rate_3: 0,
      happy_rate_4: 0,
      happy_rate_5: 0,
    };

    if (Array.isArray(CSATFeedbackData)) {
      const newData = CSATFeedbackData.reduce(
        (prev, curr) => {
          if (curr?.rate_your_coach >= 1 && curr?.rate_your_coach <= 5) {
            const ratingKey = `coach_rating_${curr?.rate_your_coach}`;
            prev = { ...prev, [ratingKey]: prev[ratingKey] + 1 };
          }
          if (curr?.happy_with_traya >= 1 && curr?.happy_with_traya <= 5) {
            const happyKey = `happy_rate_${Number(curr?.happy_with_traya)}`;
            prev = { ...prev, [happyKey]: prev[happyKey] + 1 };
          }
          return prev;
        },
        { ...objData }
      );

      setCSATFeedbackData(newData);
    }
  }, [CSATFeedbackData]);

  useEffect(() => {
    const objData = {
      satisfied_0: 0,
      satisfied_1: 0,
      experience_1: 0,
      experience_2: 0,
      experience_3: 0,
      experience_4: 0,
      experience_5: 0,
    };
    if (
      Array.isArray(ticketFeedback?.feedbacks) &&
      ticketFeedback?.feedbacks?.length !== 0
    ) {
      const updatedFeedbackData = ticketFeedback?.feedbacks?.reduce(
        (prev, feedback) => {
          const satisfiedKey = `satisfied_${feedback?.satisfied}`;
          if (feedback?.satisfied === 0 || feedback?.satisfied === 1) {
            prev = { ...prev, [satisfiedKey]: prev[satisfiedKey] + 1 };
          }
          const experienceKey = `experience_${feedback?.experience}`;
          if (feedback?.experience >= 1 && feedback?.experience <= 5) {
            prev = { ...prev, [experienceKey]: prev[experienceKey] + 1 };
          }
          return prev;
        },
        { ...objData }
      );
      setFeedbackData(updatedFeedbackData);
    }
  }, [ticketFeedback]);

  const ExcelDownload = (excelData) => {
    const _data = excelData?.map((el) => {
      return {
        ...el,
        agentName: el.rep ? el.rep?.first_name : "",
        updatedAt: moment(el.updatedAt).format("YYYY/MM/DD HH:mm:ss"),
      };
    });
    const data = [
      {
        sheet: "Customer Feedbacks",
        columns: [
          { label: "Customer Name", value: "user.first_name" },
          { label: "Agent Name", value: "agentName" },
          { label: "Order display id", value: "order_display_id" },
          { label: "Cart link", value: "cart_link" },
          { label: "Cart link (3 months)", value: "cart_link_3m" },
          { label: "Last Updated", value: "updatedAt" },
        ],
        content: _data,
      },
    ];

    let settings = {
      fileName: "Customer feedbacks",
      extraLength: 3,
      writeMode: "writeFile",
      writeOptions: {},
    };
    xlsx(data, settings);
  };

  return (
    <div>
      <FeedbackHeader
        feedbackPage={feedbackPage}
        applyDate={applyDate}
        setTable={setTable}
        table={table}
        buildPlan={plan}
        csatFeedback={csatFeedback}
        feedbackData={feedbackData}
        planLength={sortData?.length}
        csatLength={CSATFeedbackData?.length}
        feedBackLength={ticketFeedback?.count}
      />
      {table === "customer" && (
        <div className="mt-2">
          <CardDiv
            title={
              <div className="d-flex justify-content-between align-items-center">
                <div className="fs-2">Customer Feedback</div>
                <div>
                  <Button
                    type="primary"
                    icon={<DownloadOutlined />}
                    onClick={() => ExcelDownload(sortData)}
                    disabled={isEmpty(sortData)}
                  >
                    Download
                  </Button>
                </div>
              </div>
            }
            component={
              <div className="">
                <CustomerTable
                  data={filterData}
                  isLoading={isCustomerFeedbackLoading}
                  error={"error"}
                  opa={opa}
                  handleSortUpdatedDate={handleSortUpdatedDate}
                  isAction={true}
                />
                <PaginationDiv
                  paginationData={{ pageCount: pageCount || 1, page: page }}
                  newPage={newPage}
                />
              </div>
            }
          />
        </div>
      )}
      {table === "csat" && (
        <CSATFeedbackTable
          data={CSATFeedbackData}
          isLoading={isCSATFeedbackLoading}
        />
      )}
      {table === "ticket" && (
        <TicketFeedbackTable
          data={ticketFeedback}
          isLoading={isTicketFeedbackLoading}
          feedbackPage={feedbackPage}
          setFeedbackNewPage={setFeedbackNewPage}
        />
      )}
    </div>
  );
}

export default Feedback;
